<template>
  <div class="empty-con">
    <img src="@/assets/images/empty.png" alt="">
    <div class="txt">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: 'Empty'
}
</script>

<style lang="less" scoped>
.empty-con {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  padding: 40px 0;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: #fff;
  border-radius: 12px;
  img {
    width: 100px;
  }
  .txt {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
  }
}
</style>
